import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../ui/button";

export const PageHeader = ({ title, subtitle, actions, eyebrow }) => (
  <div className="mb-6 flex flex-col gap-3 border-b border-slate-200 pb-5 md:flex-row md:items-end md:justify-between">
    <div>
      {eyebrow && <div className="mb-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-sky-700">{eyebrow}</div>}
      <h1 data-testid="page-title" className="text-2xl font-semibold tracking-tight text-slate-900 md:text-3xl">{title}</h1>
      {subtitle && <p className="mt-1 max-w-3xl text-sm text-slate-500">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export const Card = ({ title, actions, children, className = "", testId }) => (
  <section data-testid={testId} className={`rounded-md border border-slate-200 bg-white shadow-sm ${className}`}>
    {title && (
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3">
        <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
        {actions}
      </div>
    )}
    <div className="p-5">{children}</div>
  </section>
);

export const Pager = ({ meta, onPage }) =>
  meta && meta.pages > 1 ? (
    <div className="flex items-center justify-between px-1 py-3 text-xs text-slate-500" data-testid="pager">
      <span>
        Page {meta.page} of {meta.pages} · {meta.total} records
      </span>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" disabled={meta.page <= 1} onClick={() => onPage(meta.page - 1)} data-testid="pager-prev">
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <Button size="sm" variant="outline" disabled={meta.page >= meta.pages} onClick={() => onPage(meta.page + 1)} data-testid="pager-next">
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  ) : meta ? (
    <div className="px-1 py-3 text-xs text-slate-500">{meta.total} records</div>
  ) : null;

export const Field = ({ label, children, hint, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="mb-1 block text-xs font-medium text-slate-600">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-[11px] text-slate-400">{hint}</span>}
  </label>
);

export const Empty = ({ text = "No records found." }) => (
  <div className="py-10 text-center text-sm text-slate-400" data-testid="empty-state">{text}</div>
);

export const Th = ({ children, className = "" }) => (
  <th className={`whitespace-nowrap border-b border-slate-200 bg-slate-50 px-4 py-2.5 text-left text-[11px] font-semibold uppercase tracking-wider text-slate-500 ${className}`}>{children}</th>
);

export const Td = ({ children, className = "" }) => <td className={`border-b border-slate-100 px-4 py-2.5 align-top text-xs text-slate-700 ${className}`}>{children}</td>;
